export default {
  data () {
    return {
      annotationX: null,
      annotationTimer: null
    }
  },
  methods: {
    _chartOptions (params) {
      let {
        id,
        group = 'graph',
        stacked = false,
        colors,
        strokeWidth,
        strokeDashArray,
        yMax = max => max ,
        yFormatter = (v) => this._$(v, 0),
        tooltipEnabledSeries,
        annotationX,
        legendShow = true
      } = params

      return {
        chart: {
          // id: `${this.print ? 'print_' : ''}${id}`,
          // group: `${this.print ? 'print_' : ''}graph`,
          id, 
          group,
          stacked,
          toolbar: { show: false },
          zoom: { enabled: false },
          events: {
            click: (event, chartContext, config) => {
              // this.$emit('percent-change', Math.max(Math.min(config.dataPointIndex, 100), 0))
              this.splitPercent = Math.max(Math.min(config.dataPointIndex, 100), 0)
            },
            updated: () => {
              if (this.graphUpdated) this.graphUpdated(id)
            }
          }
        },
        legend: {
          show: legendShow
        },
        annotations: {
          xaxis: [
            {
              x: annotationX,
              borderColor: '#775DD0',
            }
          ]
        },
        // colors: colors,
        ...( colors ? { colors } : {}),
        stroke: {
          ...( strokeWidth ? { width: strokeWidth } : { width: 3 }),
          ...( strokeDashArray ? { dashArray: strokeDashArray } : {}),
        },
        xaxis: {
          categories: this.xValues,
          axisTicks: { show: false },
          labels: { 
            style: { fontSize: 0 },
            hideOverlappingLabels: false,
            formatter: (value) => `${value}%`,
          },
          tooltip: { enabled: false }
        },
        yaxis: {
          max: yMax,
          labels: {
            minWidth: 70,
            formatter: yFormatter
          },
        },
        tooltip: {
          ...( tooltipEnabledSeries ? { enabledOnSeries: tooltipEnabledSeries } : {}),
          x: {
            formatter: (v) => `${this.xValues[v - 1]}% Split percentage (click to set)`
            // TODO: if apexcharts is updated check this is not broken
            // https://github.com/apexcharts/vue-apexcharts/issues/269
          }
        }
      }
    },
    setGraphAnnotations (percent) {
      const setAnnotation = (chartRef) => {
        if (!this.$refs[chartRef]) return 
        this.$refs[chartRef].clearAnnotations()
        this.$refs[chartRef].addXaxisAnnotation({
          x: `${percent}%`,
          strokeDashArray: 3,
          borderColor: '#775DD0',
          label: {
            borderColor: '#775DD0',
            style: {
              color: '#fff',
              background: '#775DD0'
            },
          }
        })
      }

      if (this.annotationTimer) clearTimeout(this.annotationTimer)

      this.annotationTimer = setTimeout(() => {
        Object.keys(this.$refs).forEach(ref => {
          if (ref.includes('graph_')) setAnnotation(ref)
        })

      }, 50)
    }
  },
  watch: {
    splitPercent (v) {
      this.setGraphAnnotations(Math.round(v))
    }
  }
}